export default "__VITE_ASSET__BCl7TGrJ__"